export type { CopilotChatProps, CopilotChatSlots, CopilotChatState } from './components/CopilotChat/index';
export { CopilotChat, copilotChatClassNames, renderCopilotChat_unstable, useCopilotChatStyles_unstable, useCopilotChat_unstable } from './components/CopilotChat/index';
